export default "<div *ngIf=\"pageLoaderFlag\">\r\n  <app-square-loading></app-square-loading>\r\n</div>\r\n<router-outlet></router-outlet>\r\n"